import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../../api/client';
import type { BranchDto, CreateBranchRequest, UpdateBranchRequest } from './types';

const QK_LIST = ['branches'] as const;

export function useBranches() {
  return useQuery({
    queryKey: QK_LIST,
    queryFn: async () => (await apiClient.get<BranchDto[]>('/api/branches')).data,
  });
}

export function useCreateBranch() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (request: CreateBranchRequest) =>
      (await apiClient.post<BranchDto>('/api/branches', request)).data,
    onSuccess: () => qc.invalidateQueries({ queryKey: QK_LIST }),
  });
}

export function useUpdateBranch() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, request }: { id: string; request: UpdateBranchRequest }) =>
      (await apiClient.put<BranchDto>(`/api/branches/${id}`, request)).data,
    onSuccess: () => qc.invalidateQueries({ queryKey: QK_LIST }),
  });
}

export function useDeleteBranch() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      await apiClient.delete(`/api/branches/${id}`);
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: QK_LIST }),
  });
}
